export default __webpack_public_path__ + "images/be81966d4e8befe0f96861b8ffc9d982.png";